// extracted by mini-css-extract-plugin
export var label = "_e3-2";
export var slideContainer = "_e3-0";
export var slider = "_e3-1";